import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assests/AA1.jpg'
import HeaderSocials from './HeaderSocials'

const Header = () => {
  return (
    <header>
      <div className='container header__container'>
        <h5>Hey! I am</h5>
        <h1>Muhammad Ahmad</h1>
        <h2>Gold Medalist</h2>
        <h5 className='text-light'>Cinematographer</h5>
        <h5 className='text-light'>Creative Director</h5>
        <h5 className='text-light'>Photographer | Public Speaker</h5>
        <CTA/>
        <HeaderSocials/>

        <div className="me">
          <img src={ME} alt="me" />
          
        </div>
        <a href='#contact' className='scroll__down'>Scroll Down</a>
        

      </div>
    </header>
  )
}

export default Header